// The hostname decides everything (CTR-ARCHITECTURE): apex/www render the
// public landing + signup; <slug>.clearedto.rent renders that school's
// portal, with /dashboard as the school-owner shell. Unclaimed schools are
// routed inside SchoolPortal (the status rides the by-slug response).
// /signin and /auth/callback exist on BOTH hosts (round 3 §2): the magic
// link lands on the school's own host when known, the apex otherwise.
// Local dev uses ?school=<slug> or a host-resolver mapping.
import { Routes, Route } from 'react-router-dom';
import { slugFromLocation } from '@/lib/api.js';
import Landing from './routes/Landing.jsx';
import Signup from './routes/Signup.jsx';
import SchoolPortal from './routes/SchoolPortal.jsx';
import Dashboard from './routes/Dashboard.jsx';
import Signin from './routes/Signin.jsx';
import AuthCallback from './routes/AuthCallback.jsx';
import Quote from './routes/Quote.jsx';
import PolicyDiff from './routes/PolicyDiff.jsx';

export default function App() {
  const slug = slugFromLocation();
  if (slug) {
    return (
      <Routes>
        <Route path="/dashboard" element={<Dashboard slug={slug} />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/policy-diff" element={<PolicyDiff />} />
        <Route path="*" element={<SchoolPortal slug={slug} />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/signup" element={<Signup />} />
      <Route path="/signin" element={<Signin />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/quote" element={<Quote />} />
      <Route path="/renter" element={<Quote />} />
      <Route path="/cfi" element={<Quote cfiPreset />} />
      <Route path="/policy-diff" element={<PolicyDiff />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}
